
import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface TableParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface Table {
  Id?: any;
  tableNo: string;
  nursingCounterId:any;
  tableFlag: any;
  OTTheatreId?:number;
  rent: any;
  tenantId?: string;
  branchId?: string;
  createdby?: string;
  createddate?: any;
  updatedby?: string;
  updateddate?: any;
    parameters?: TableParameter[];
    links?: any;
}

export abstract class TableData {
 
  abstract list(url: string): Observable<Table[]>;
  abstract create(url: string,data: Table): Observable<any>;
  abstract update(url: string,data: Table): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
